let swiper;
const sliderBlock = document.querySelector('.hover-slider');
const breakpoint = window.matchMedia('(max-width: 767px)');

const initSlider = () => {
  swiper = new Swiper('.hover-slider', {
    slidesPerView: 'auto',
    spaceBetween: 18,
    // centeredSlides: true,
    navigation: {
      nextEl: '.hover-slider__btn-mobile-right',
      prevEl: '.hover-slider__btn-mobile-left',
    },
  });
};


const initHoverSlider = () => {
  if (!sliderBlock) {
    return;
  }

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      initSlider();
    } else {
      if (swiper) {
        swiper.destroy();
      }
    }
  };
  breakpointChecker();
  breakpoint.addListener(breakpointChecker);
};

export {initHoverSlider};
